(function () {
  /* Side cart (Qikify): show the per-unit price next to each line total, and show the real unit count in the badge. */
  var timer, busy = false, last = '';
  function money(c) { return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function paint(cart) {
    var rows = document.querySelectorAll('.qsc2-drawer-rows .qsc2-product-item');
    rows.forEach(function (row, i) {
      var it = cart.items[i]; if (!it || !it.quantity) return;
      var wrap = row.querySelector('.qsc2-product-item__line-price-wrapper'); if (!wrap) return;
      var unit = it.final_line_price / it.quantity, list = it.original_price;
      var html = '<span class="rg-unit__now">' + money(unit) + '</span> each' + (list - unit > 1 ? ' <s>' + money(list) + '</s>' : '');
      var el = wrap.querySelector('.rg-unit');
      if (!el) { el = document.createElement('div'); el.className = 'rg-unit'; wrap.appendChild(el); }
      if (el.getAttribute('data-k') !== html) { el.innerHTML = html; el.setAttribute('data-k', html); }
    });
    var cb = document.querySelector('.qsc2-checkout-button');
    if (cb && !/purchase order/i.test(cb.textContent)) { var inner = cb.querySelector('span') || cb; inner.textContent = 'Start A Purchase Order'; }
    var badge = document.querySelector('.qsc2-drawer-header__badge');
    if (badge && cart.item_count > 99 && badge.textContent.trim() !== String(cart.item_count)) badge.textContent = cart.item_count;
  }
  function run() {
    if (busy || !document.querySelector('.qsc2-drawer-rows .qsc2-product-item')) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(paint).catch(function () {}).then(function () { busy = false; });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(run, 120); }
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  schedule();
})();
